import { z } from 'zod';
import { convertAmountToMonthlyPeriod, requiredFieldError, validateExpense } from '../../helper';
import { Period } from '../../types';
import { amountApplicable } from './amount';

export const expense = z.object({
  mortgage: amountApplicable
    .superRefine((data, ctx) => validateExpense({ data, ctx, requireIsNotApplicable: true }))
    .transform(data => {
      if (!data.isNotApplicable) {
        return data;
      }
      return {
        ...data,
        amount: 0,
        period: Period.Monthly,
      };
    }),
  rent: amountApplicable
    .superRefine((data, ctx) => validateExpense({ data, ctx, requireIsNotApplicable: true }))
    .transform(data => {
      if (!data.isNotApplicable) {
        return data;
      }
      return {
        ...data,
        amount: 0,
        period: Period.Monthly,
      };
    }),
  household: amountApplicable
    .default({ amount: 0, period: Period.Monthly })
    .superRefine((data, ctx) => validateExpense({ data, ctx, isMonthlyExpense: true }))
    .transform(data => {
      if (!data.period || data.period === Period.Monthly || data.amount === undefined || data.amount === null) {
        return data;
      }
      return {
        ...data,
        amount: Math.round(convertAmountToMonthlyPeriod(data.amount, data.period) * 100) / 100,
        period: Period.Monthly,
      };
    }),
  otherLoans: amountApplicable
    .default({ amount: 0, period: Period.Monthly })
    .superRefine((data, ctx) => validateExpense({ data, ctx, isMonthlyExpense: true, requireIsNotApplicable: true }))
    .transform(data => {
      if (!data.isNotApplicable) {
        return data;
      }
      return {
        ...data,
        amount: 0,
        period: Period.Monthly,
      };
    }),
  investmentProperties: amountApplicable
    .superRefine((data, ctx) => validateExpense({ data, ctx, requireIsNotApplicable: true, allowZeroAmount: true }))
    .transform(data => {
      if (!data.isNotApplicable) {
        return data;
      }
      return {
        ...data,
        amount: 0,
        period: Period.Monthly,
      };
    })
    .optional(),
  creditCards: z
    .object({
      limit: z.number().optional(),
      isNotApplicable: z.boolean().optional(),
    })
    .transform(data => {
      if (data.isNotApplicable) {
        return { ...data, limit: 0 };
      }
      return data;
    })
    .superRefine((data, ctx) => {
      const { isNotApplicable, limit } = data;
      if (isNotApplicable === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: requiredFieldError(),
          path: ['isNotApplicable'],
        });
        return;
      }
      if (!isNotApplicable && (!limit || limit <= 0)) {
        ctx.addIssue({
          code: z.ZodIssueCode.too_small,
          minimum: 1,
          type: 'number',
          inclusive: true,
          message: requiredFieldError(),
          path: ['limit'],
        });
      }
    }),
});
